import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Page from '../../../Common/Page';

import ProgressIndicator from '../../../Common/ProgressIndicator';
import ErrorIndicator from '../../../Common/ErrorIndicator';
import EventInfo from './EventInfo';
import RegistrationSection from './Registration/RegistrationSection';
import Participants from './Participants';
import MemberSection from './MemberSection/MemberSection';
import Axios from 'axios';
import Organisers from './Organisers';

function EventDetailedPage(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [event, setEvent] = useState(null);
    const [refreshFlag, setRefreshFlag] = useState(false);
    const { id } = useParams();

    useEffect(() => {
        setIsLoading(true);
        Axios.get(`/events/${id}`).then(res => {
            setEvent(res);
            setIsLoading(false);
        }, err => {
            setIsLoading(false);
            setError(true);
        });
    }, [id, refreshFlag]);

    function triggerUpdate(){
        setRefreshFlag(!refreshFlag);
    }

    if (isLoading)
        return <ProgressIndicator />;

    if (error)
        return <ErrorIndicator text="A rendezvény letöltése sikertelen." />;

    if (event)
        return (
            <Page centered>
                <h2>{event.name}</h2>
                <EventInfo event={event} />
                <RegistrationSection event={event} callback={triggerUpdate} />
                <MemberSection {...props} callback={triggerUpdate} />
                <Organisers organisers={event.organisers} />
                <Participants participants={event.participants} />
            </Page>
        );

    return null;
}

export default EventDetailedPage;